import { SectionWrapper } from "../hoc";
import "./Tech.css";
import { styles } from "../styles";
import { motion } from "framer-motion";
import { textVariants } from "../utils/motion";

import { Link } from "react-router-dom";
import { technologies } from "../constants";

export const fadeInTechVariantConst = {
  initial: {
    opacity: 0,
    y: 100,
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      type: "easeIn",
      delay: 0.5,
      duration: 0.3,
    },
  },
};

const Tech = () => {
  const handleIconClick = (index) => {
    // implement redirect or some note
  };

  return (
    <div className="mt-8">
      <motion.div variants={textVariants()}>
        <p className={styles.sectionSubText}>What technologies and tools have I already used?</p>
        <h2 className={styles.sectionHeadText}>Technologies.</h2>
      </motion.div>
      <div className="mt-16">
        <ul className="tech-flex gap-10">
          {technologies.map((item, index) => (
            <motion.li
              key={index}
              className="cursor-pointer tech-item"
              onClick={() => handleIconClick(index)}
              variants={fadeInTechVariantConst}
              initial="initial"
              whileInView="animate"
              viewport={{
                once: true,
              }}
            >
              <Link to={item.path} className="flex flex-col items-center text-white">
                <div className="border-container">
                  <div className="border-layer layer1"></div>
                  <div className="border-layer layer2"></div>
                  <div className="border-layer layer3"></div>
                  <div className="border-layer layer4"></div>
                  <div className="icon-container">
                    <span className="text-6xl">{item.icon}</span>
                  </div>
                </div>
                <span className="mt-2">{item.text}</span>
              </Link>
            </motion.li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SectionWrapper(Tech);
